import React from "react"

import ThemeHeaderComponent from "./theme-header-component"

class ThemeHeaderContainer extends React.Component {

	render() {
		return (
			<ThemeHeaderComponent {...this.props} />
		)
	}

}

export default ThemeHeaderContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/theme-header-container.js